<template>
  <v-dialog v-model="showDialog" persistent max-width="1200px">
    <v-card>
      <!-- <v-card-title  color="primary darken-4">
                                <span class="headline">AGREGAR SUCURSAL</span>
      </v-card-title>-->
      <v-toolbar color="primary darken-4" dark>
        <img
          :src="$store.state.iconoForm"
          height="42"
          alt="Acciones tipo producto"
        />
        <v-toolbar-title class="ml-0 pl-3">
          <span class="hidden-sm-and-down">{{ $store.state.tituloForm }}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="showDialog = false">
          <v-icon danger>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text>
        <v-container grid-list-md>
          <h5>{{ producto.descripcion }}</h5>
          <v-tabs dark color="primary" show-arrows>
            <v-tabs-slider color="primary darken-4"></v-tabs-slider>

            <v-tab :href="'#tab-generales'">Generales</v-tab>
            <v-tab :href="'#tab-fotos'" v-if="producto.productoId !== 0"
              >Fotos</v-tab
            >
            <v-tab :href="'#tab-catalogo'" v-if="producto.productoId !== 0"
              >Catálogo</v-tab
            >
            <v-tab :href="'#tab-inventario'" v-if="producto.productoId !== 0"
              >Inventario</v-tab
            >

            <v-tabs-items>
              <v-tab-item :value="'tab-generales'">
                <v-form ref="formProducto" :v-model="true" lazy-validation>
                  <v-layout wrap class="container">
                    <v-flex xs12 sm12 md12>
                      <v-select
                        v-model="producto.tipoProductoId"
                        :items="tiposProducto"
                        item-text="descripcion"
                        item-value="tipoProductoId"
                        label="Tipo de producto"
                        :loading="loadingTiposProducto"
                        placeholder="Tipo de producto"
                        single-line
                        @input="getLineasProducto"
                        :rules="[
                          () =>
                            !!producto.tipoProductoId ||
                            'El campo es requerido',
                        ]"
                        required
                      ></v-select>
                    </v-flex>

                    <v-flex xs12 sm12 md12>
                      <v-select
                        v-model="producto.lineaProductoId"
                        :items="lineasProducto"
                        item-text="descripcion"
                        item-value="lineaProductoId"
                        label="Línea de producto"
                        :loading="loadingLineasProducto"
                        placeholder="Línea de producto"
                        single-line
                        @input="setDescription"
                        :rules="[
                          () =>
                            !!producto.lineaProductoId ||
                            'El campo es requerido',
                        ]"
                        required
                      ></v-select>
                    </v-flex>

                    <v-flex xs12 sm12 md12>
                      <v-select
                        v-model="producto.marcaId"
                        :items="marcas"
                        item-text="nombreMarca"
                        item-value="marcaId"
                        label="Marca"
                        :loading="loadingMarcas"
                        placeholder="Marca"
                        single-line
                        @input="setDescription"
                        :rules="[
                          () => !!producto.marcaId || 'El campo es requerido',
                        ]"
                        required
                      ></v-select>
                    </v-flex>

                    <v-flex xs12 sm12 md12>
                      <v-text-field
                        label="Descripción del producto"
                        v-model="producto.descripcion"
                        placeholder="Descripción"
                        hint="Descripción del producto"
                        :rules="[
                          () =>
                            !!producto.descripcion || 'El campo es requerido',
                        ]"
                        required
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md12>
                      <v-text-field
                        label="Modelo / Abreviación"
                        v-model="producto.modelo"
                        placeholder="Modelo o abreviación, ejemplo: SAC001, PAN010, CAM001, COR001"
                        hint="Modelo"
                        :rules="[
                          () => !!producto.modelo || 'El campo es requerido',
                        ]"
                        required
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md12 class="text-md-right">
                      <v-btn
                        color="primary darken-4"
                        :loading="$store.state.operationInProgress"
                        @click="saveProducto"
                        >Guardar producto</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-tab-item>
              <v-tab-item :value="'tab-fotos'">
                <v-layout wrap class="container">
                  <v-flex xs12 sm12 md12>
                    <fotos-producto
                      v-if="producto.productoId !== 0"
                      :producto="producto"
                    ></fotos-producto>
                  </v-flex>
                </v-layout>
              </v-tab-item>
              <v-tab-item :value="'tab-catalogo'">
                <v-layout wrap class="container">
                  <v-flex xs12 sm12 md12>
                    <catalogo-producto
                      v-if="producto.productoId !== 0"
                      :producto="producto"
                      @onCatalogoProductoCrud="onCatalogoProductoCrud"
                    ></catalogo-producto>
                  </v-flex>
                </v-layout>
              </v-tab-item>
              <v-tab-item :value="'tab-inventario'">
                <v-layout wrap class="container">
                  <v-flex xs12 sm12 md12>
                    <inventario-producto
                      v-if="producto.productoId !== 0"
                      :producto="producto"
                      ref="inventarioProducto"
                    ></inventario-producto>
                  </v-flex>
                </v-layout>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-container>
        <br />
        <small>* Indica que el campo es requerido</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn depressed @click.native="showDialog = false"
          >Cerrar ventana</v-btn
        >
      </v-card-actions>
      <v-alert
        :value="$store.state.operationSuccess"
        color="success"
        icon="check_circle"
        transition="scale-transition"
        >{{ mensajeProducto }}</v-alert
      >
      <v-alert
        :value="$store.state.fail"
        color="error"
        icon="warning"
        transition="scale-transition"
      >
        <span v-html="$store.state.errorMessage"></span>
      </v-alert>
    </v-card>
  </v-dialog>
</template>

<script>
//Components
import fotosProducto from "@/views/producto-fotos/ProductoFotos";
import catalogoProducto from "@/views/producto-catalogo/ProductoCatalogo";
import inventarioProducto from "@/views/producto-inventario/ProductoInventario";

//Services
import tipoProductoService from "@/services/tipoProductoService";
import lineaProductoService from "@/services/lineaProductoService";
import marcaProductoService from "@/services/marcaProductoService";
import productoService from "@/services/productoService";

export default {
  components: {
    fotosProducto,
    catalogoProducto,
    inventarioProducto,
  },
  props: {
    producto: {
      type: Object,
    },
  },
  watch: {
    producto: function (val) {
      if (val.productoId !== 0) {
        this.getLineasProducto();
      }
    },
  },
  data() {
    return {
      showDialog: false,
      tiposProducto: [],
      lineasProducto: [],
      marcas: [],
      loadingTiposProducto: false,
      loadingLineasProducto: false,
      loadingMarcas: false,
      mensajeProducto: "Producto guardado con éxito",
    };
  },
  methods: {
    openDialog() {
      this.showDialog = true;
      this.getTiposProducto();
      this.getMarcas();
    },
    getTiposProducto() {
      let self = this;
      self.loadingTiposProducto = true;
      tipoProductoService
        .getAll()
        .then((result) => {
          self.tiposProducto = result;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        })
        .finally(() => {
          self.loadingTiposProducto = false;
        });
    },
    getLineasProducto() {
      let self = this;
      self.loadingLineasProducto = true;
      let tipoProductoId = self.producto.tipoProductoId;
      lineaProductoService
        .getAllByTipoProducto(tipoProductoId)
        .then((result) => {
          self.lineasProducto = result;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        })
        .finally(() => {
          self.loadingLineasProducto = false;
        });
    },
    getMarcas() {
      let self = this;
      self.loadingMarcas = true;
      marcaProductoService
        .getAll()
        .then((result) => {
          self.marcas = result;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        })
        .finally(() => {
          self.loadingMarcas = false;
        });
    },
    saveProducto() {
      let self = this;

      if (self.$refs.formProducto.validate()) {
        self.operationStart();

        if (self.producto.productoId === 0) {
          self.addProducto();
        } else {
          self.updateProducto();
        }
      }
    },
    addProducto() {
      let self = this;

      productoService
        .add(self.producto)
        .then((result) => {
          self.mensajeProducto = "Producto guardado con éxito";
          self.operationSuccess();

          //Enviar tipo producto al componente padre
          self.$emit("onProductoAdded", result);

          // setTimeout(() => {
          //     self.showDialog = false
          //     self.resetForm();
          // }, 2000);
          self.producto.productoId = result.productoId;
        })
        .catch((e) => {
          self.operationFailed(e);
          console.log(e);
        });
    },
    updateProducto() {
      let self = this;

      productoService
        .update(self.producto)
        .then((result) => {
          self.operationSuccess();

          //Enviar tipo producto al componente padre
          self.$emit("onProductoUpdated", result);

          setTimeout(() => {
            self.showDialog = false;
            self.resetForm();
          }, 2000);
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        });
    },
    setDescription() {
      let self = this;
      self.producto.descripcion = "";

      if (self.producto.tipoProductoId !== 0) {
        let tipoProductoSelected = self.tiposProducto.find(
          (t) => t.tipoProductoId === self.producto.tipoProductoId
        );
        self.producto.descripcion += tipoProductoSelected.descripcion;
      }

      if (self.producto.lineaProductoId !== 0) {
        let lineaProductoSelected = self.lineasProducto.find(
          (t) => t.lineaProductoId === self.producto.lineaProductoId
        );
        self.producto.descripcion += " " + lineaProductoSelected.descripcion;
      }

      if (self.producto.marcaId !== 0) {
        let marcaSelected = self.marcas.find(
          (t) => t.marcaId === self.producto.marcaId
        );
        self.producto.descripcion += " " + marcaSelected.nombreMarca;
      }
    },
    onCatalogoProductoCrud() {
      let self = this;
      self.$refs.inventarioProducto.extraerInventarioProducto();
    },
    resetForm() {
      let self = this;
      self.operationReset();
      self.$refs.formProducto.resetValidation();
      self.producto.productoId = 0;
      (self.producto.descripcion = ""),
        (self.producto.tipoProductoId = 0),
        (self.producto.lineaProductoId = 0),
        (self.producto.marcaId = 0),
        (self.producto.modelo = "");
    },
  },
};
</script>
